import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/experience-platform-apis/experience-platform-apis/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import GetCredentialsOauth2 from "../credentials/GetCredentialOAuth2.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const RedoclyAPIBlock = makeShortcode("RedoclyAPIBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <GetCredentialsOauth2 mdxType="GetCredentialsOauth2" />
    <RedoclyAPIBlock disableSearch="true" ctrlFHijack="false" src="/experience-platform-apis/swagger-specs/audit-query.yaml" mdxType="RedoclyAPIBlock" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      